import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../../../css/Compliance/MembersHub/FileDirectory.css";
import PortalCard from "../../../frontend/DesignSystem/Cards/PortalCard";
import Sidebar from "../../../frontend/DesignSystem/Sidebar";
import { faBell } from "@fortawesome/free-solid-svg-icons";
import { useUserPermissions } from "../../SignIn/UserPermissionsContext";
import { use, useEffect, } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Breadcrumb from "../../../frontend/DesignSystem/Breadcrumb/Breadcrumb";
const FileDirectory = () => {
  const { userPermissions } = useUserPermissions();

  const navigate = useNavigate();

 useEffect(() => {
   if (
     !userPermissions.includes("Compliance") &&
     !userPermissions.includes("Marketing")
   ) {
     navigate("/");
   }
 }, [userPermissions, navigate]);


  return (
    <div className="Main-Page">
      <Helmet>
        <title>Members Hub - Compliance</title>
        <meta
          name="description"
          content="Access various resources and documents related to mortgages, protection, equity release, financial planning, and more."
        />
      </Helmet>
      <Sidebar />
      <div className="Main-Container">
        <div className="Folder-Container">
          <Breadcrumb
            items={[
              {
                label: "Compliance",
                to: "/Department/Compliance",
              },
              { label: "Members Hub" },
            ]}
          />

          {userPermissions.includes("Administrator") && (
            <FontAwesomeIcon
              icon={faBell}
              className="NotificationIcon"
              onClick={() => {
                navigate("/MembersHub/Activity");
              }}
            />
          )}

          <h2>Members Hub</h2>
          <div className="Folder-Container-Holder">
            {[
              {
                id: "intelliflo",
                title: "Intelliflo",
                link: "/MembersHub/Intelliflo",
              },
              {
                id: "mortgages",
                title: "Mortgages",
                link: "/MembersHub/Mortgages",
              },
              {
                id: "protection",
                title: "Protection & GI",
                link: "/MembersHub/Protection & GI",
              },
              {
                id: "equity-release",
                title: "Equity Release",
                link: "/MembersHub/Equity Release",
              },
              {
                id: "financial-planning",
                title: "Financial Planning",
                link: "/MembersHub/Financial Planning",
              },
              {
                id: "policy-docs",
                title: "Policy & Procedure Documents",
                link: "/MembersHub/Policy & Procedure Documents",
              },
              {
                id: "user-guides",
                title: "User Guides & Links",
                link: "/MembersHub/Useful Guides & Links",
              },
              {
                id: "updates",
                title: "Bulletins & Updates",
                link: "/MembersHub/Bulletins & Updates",
              },
              {
                id: "customer-material",
                title: "Customer Facing Material",
                link: "/MembersHub/Customer Facing Material",
              },
              {
                id: "competent-adviser",
                title: "Competent Adviser & Logging your CPD",
                link: "/MembersHub/Competent Adviser & Logging your CPD",
              },
              {
                id: "business-resources",
                title: "Mortgage & Protection Business Resources",
                link: "/MembersHub/Mortgage & Protection Business Resources",
              },
              // {
              //   id: "meet-the-team",
              //   title: "Meet the Team",
              //   link: "/MembersHub/Meet the Team",
              // },

              {
                id: "paraplanning",
                title: "Paraplanning Resources",
                link: "/MembersHub/Paraplanning Resources",
              },
            ].map(({ id, title, link }) => (
              <div key={id} id={id}>
                <PortalCard title={title} link={link} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FileDirectory;
